<template>
    <div id="security"
         class="security tr">
        <h3>Security</h3>
        <h4>Two-factor authentication method</h4>
        <div id="security_settings">
            <param-component :input-label="'For login'"
                             :list="loginOptions"
                             :param-key="'two_step_login'"
                             :param-label="'Two step login'"
                             :param-name="'twoStepLogin'"
                             :param-settings-name="'TWO_STEP_LOGIN_VERIFICATION'"></param-component>
            <param-component :input-label="'For payouts'"
                             :list="payoutsOptions"
                             :param-key="'payouts'"
                             :param-label="'Payouts'"
                             :param-name="'payouts'"
                             :param-settings-name="'TWO_STEP_PAYOUT_VERIFICATION'"></param-component>
        </div>
        <p style="margin-top: 30px">
            <router-link :to="{'name': 'TermsUpdate'}"
                         style="color: red">Show the selected consents and statements <i class="mdi mdi-chevron-right"></i></router-link>
        </p>
    </div>
</template>

<script>
    import ParamComponent from './security/Param';

    export default {
        dependencies: ['settings'],
        components: { ParamComponent },
        data () {
            return {
                loginOptions: {
                    NOT_CONFIGURED: '-',
                    EMAIL: 'e-mail',
                    GOOGLE_AUTHENTICATOR: 'google authenticator'
                },
                payoutsOptions: {
                    EMAIL: 'e-mail',
                    GOOGLE_AUTHENTICATOR: 'google authenticator'
                },
            }
        },
        mounted () {
            this.$store.commit('resetTemporarySettings')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .security{
        margin: 33px 0;
        border-top: 1px solid $base1;

        h3{
            padding: 30px 0;
            + h4 {
                display: block;
                color: $base2;
                font-size: 13px;
                font-weight: bold;
                text-transform: uppercase;
                line-height: 30px;
                margin: -35px 0 50px;
            }
        }

        button,
        .col{
            margin-top: 10px;
        }

        button{
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/Security.vue